import AnalyticsHelper from '../../utils/analytics-helper.js';
import DealerMapper from '../../utils/dealer-mapper.js';

export default class DealerResults {
    constructor(parent, router) {
        this.router = router;
        this.el = parent.el.querySelector('.fad-results');
        this.loader = parent.loader;
        this.resultsTemplate = _.template(parent.el.querySelector('#dealer-results').innerHTML.replaceAll('\\', ''));
        this.noResultsTemplate = _.template(parent.el.querySelector('#dealer-no-results').innerHTML.replaceAll('\\', ''));
    }

    show() {
        this.el.classList.remove('hide');
    }

    hide() {
        this.el.classList.add('hide');
    }

    render(query, results) {
        if (query) {
            const dealers = results ? results.map((result) => DealerMapper.map(result)) : [];
            this.router.data.dealers = dealers;
            const chooseDealerAriaLabelTemplate = this.el.dataset.chooseDealerAriaLabel;

            if(dealers.length > 0){
                dealers.forEach(dealer => {
                    dealer.chooseDealerAriaLabel = chooseDealerAriaLabelTemplate.replace(/\{0\}/g, dealer.name);
                });
                this.el.innerHTML = this.resultsTemplate({ query, dealers });
            } else {
                this.el.innerHTML = this.noResultsTemplate({ query });
                const noResults = this.el.querySelector('.fad-search-results');
                AnalyticsHelper.template(noResults, { query: query });
                AnalyticsHelper.push(noResults);
            }
        }

        this.loader.hide();
        this.show();
    }
}
